export enum SearchStep {
	search = 'search',
	result = 'result',
	booking = 'booking',
}

export const NOW = 'NOW' as const;
